import React, { useEffect, useState } from "react";
import ConfirmDialog from "../../../../components/actionDialogs/confirmDialog";
import Loader from "../../../../components/loader/loader";
import Snackbar from "../../../../components/snackbar/snackbar";
import CustomTable from "../../../../components/table/table";
import { admin_gallery_delete, admin_gallery_list } from "../../admin.api";
import ManageGallery from "./manage/manage";
import "./view.css";
import jwtDecode from "jwt-decode";
export default function View(props) {
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const [data, setdata] = useState([]);
  const [addNew, setAddNew] = useState(false);
  const [formData, setFormData] = useState({});
  const [edit, setEdit] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const [view, setView] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const handleEventList = () => {
    setIsActive(true);
    admin_gallery_list().then((res) => {
      let tempData = res.data;
      tempData.forEach((item, index) => {
        item["slno"] = index + 1;
      });
      setdata(tempData);
      setIsActive(false);
    });
  };
  useEffect(() => {
    handleEventList();
  }, []);
  const handleAddNew = () => {
    setAddNew(true);
    setView(false);
  };
  const handleClose = () => {
    setAddNew(false);
    setEdit(false);
    setFormData({});
    handleEventList();
  };
  const handleEdit = (data) => {
    setFormData(data);
    setView(false);
    setEdit(true);
    setAddNew(true);
  };
  const handleView = (data) => {
    setAddNew(true);
    setFormData(data);
    setView(true);
  };
  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };
  const handleCancelDelete = () => {
    setOpenAction(false);
  };
  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    admin_gallery_delete(data.uuid)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setIsActive(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setIsActive(false);
        setSnackOpen(true);
      });
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleEventList();
    }
  };
  return (
    <div>
      <Loader open={isActive} />
      <div className="view-container">
        <h6>
          <b>Images</b>
        </h6>
        <hr />
        {adminType != 23 && (
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={(e) => handleAddNew(e)}
          >
            Add New
          </button>
        )}
        <CustomTable
          {...props}
          columns={[
            { title: "SI No", type: "dynId", field: "id" },
            { title: "Image", field: "images", type: "fullimage" },
            { title: "Name", field: "image_title_en" },
            { title: "Status", field: "status", type: "status" },
          ]}
          data={data}
          {...(adminType !== 23 && {
            actions:
              adminType === 2
                ? [
                    { type: "edit", handleClick: handleEdit },
                    { type: "delete", handleClick: handleDelete },
                  ]
                : [
                    { type: "edit", handleClick: handleEdit },
                    // { type: "delete", handleClick: handleDelete },
                  ],
          })}
        />
      </div>
      {addNew && (
        <ManageGallery
          open={addNew}
          edit={edit}
          handleClose={handleClose}
          formData={formData}
        />
      )}
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Image ?"
          data={activeData}
          message="Are you sure to delete this Image?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
